import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import React from 'react';

import type { ClubLinkCard as Props } from './club-link-card.types';

const ClubLinkCard: React.FunctionComponent<Props> = ({
  href,
  name,
  address,
  distance,
}) => (
  <a className="club-link-card" href={href} aria-label={name}>
    <Text
      className="club-link-card__title"
      size={Text.sizes.header2}
      variant={Text.variants.contrast}
    >
      {name}
    </Text>
    <Text className="club-link-card__adresse">{address}</Text>
    <Text className="club-link-card__distance">{distance}</Text>
  </a>
);

export default ClubLinkCard;
